import { render } from "./GButton.vue?vue&type=template&id=4332bb7a"
import script from "./GButton.vue?vue&type=script&lang=js"
export * from "./GButton.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./GButton.vue?vue&type=style&index=0&id=4332bb7a&lang=scss&module=true"
cssModules["$style"] = style0
import style1 from "./GButton.vue?vue&type=style&index=1&id=4332bb7a&lang=scss&module=%24styleColor"
cssModules["$styleColor"] = style1

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__